import * as React from 'react';

import styles from './CatalogErrorPage.scss';

type Props = {
  variant: 'not_found' | 'generic_error';
};

export const CatalogErrorPage = ({ variant }: Props): JSX.Element => {
  const isNotFound = variant === 'not_found';

  return (
    <section
      className={styles.root}
      aria-label={isNotFound ? 'ページが見つかりませんでした' : 'ページの読み込みに失敗しました'}
      data-testid={isNotFound ? 'catalog-error-not-found' : 'catalog-error-generic'}
    >
      <div className={styles.inner}>
        <h1 className={styles.title}>
          {isNotFound ? 'お探しのページは見つかりませんでした。' : 'ページの読み込みに失敗しました。'}
        </h1>
        <p className={styles.subtitle}>
          {isNotFound ? 'URLをご確認いただくか、別のページをお試しください。' : '時間をおいて再度お試しください。'}
        </p>

        <div className={styles.actions}>
          {!isNotFound ? (
            <button
              type="button"
              className={styles.primaryButton}
              onClick={() => window.location.reload()}
            >
              再読み込み
            </button>
          ) : null}

          <a
            className={styles.secondaryLink}
            href="/"
          >
            タンプトップへ
          </a>
        </div>
      </div>
    </section>
  );
};
